import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import Header from "./Header";
import Footer from "./Footer";
import Profile from "./Profile";
import WishlistPage from "./WishlistPage";
import { useNavigate } from "react-router-dom";
import Orders from "./Orders";

const Dashboard = () => {
  const navigate = useNavigate();
  const [showLogoutPopup, setShowLogoutPopup] = useState(false);
  const [activeTab, setActiveTab] = useState("dashboard");
  const [user, setUser] = useState(null);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [ordersCount, setOrdersCount] = useState(0);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "null");

    if (!storedUser) {
      navigate("/login");
      return;
    }

    setUser(storedUser);
    fetchWishlistCount(storedUser);
  }, []);

  const getUserGuestPayload = (storedUser = user) => {
    const userId = storedUser?.id || "";
    const guestId = localStorage.getItem("guest_id") || "";

    return userId
      ? { user_id: userId, guest_id: "" }
      : { guest_id: guestId, user_id: "" };
  };

  const fetchWishlistCount = async (storedUser) => {
    try {
      const payload = getUserGuestPayload(storedUser);

      const res = await fetch(
        "https://aethearia.store/superadmin/api/wishlist-list",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (data.status) {
        setWishlistCount(data.data?.length || 0);
      } else {
        setWishlistCount(0);
      }
    } catch (error) {
      console.error("Wishlist count error:", error);
    }
  };

const handleLogout = async () => {
  try {
    const userId = user?.id || user?.user_id;

    if (userId) {
      await fetch("https://aethearia.store/superadmin/api/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: Number(userId),
        }),
      });
    }
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    localStorage.removeItem("user");
    localStorage.removeItem("token");

    setUser(null);
    navigate("/login");
  }
};

  if (!user) {
    return (
      <>
        <Header />
        <div style={{ padding: "160px 30px", textAlign: "center" }}>
          Loading dashboard...
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <div className="account-dashboard">
        <div className="sidebar">
          <div
            className={activeTab === "dashboard" ? "menu active" : "menu"}
            onClick={() => setActiveTab("dashboard")}
          >
            Dashboard
          </div>

          <div
            className={activeTab === "profile" ? "menu active" : "menu"}
            onClick={() => setActiveTab("profile")}
          >
            Profile Details
          </div>

          <div
            className={activeTab === "orders" ? "menu active" : "menu"}
            onClick={() => setActiveTab("orders")}
          >
            Orders
          </div>

          <div
            className={activeTab === "wishlist" ? "menu active" : "menu"}
            onClick={() => setActiveTab("wishlist")}
          >
            Wishlist
          </div>

          <div className="menu logout-menu" onClick={() => setShowLogoutPopup(true)}>
            Logout
          </div>
        </div>

        <div className="content">
          {activeTab === "dashboard" && (
            <>
              <h2>Good Day, {user.fname} 👋</h2>

              <p>
                Welcome to your Aethearia account dashboard. Here you can manage
                your orders, wishlist, profile details and account information.
              </p>

              <div className="dashboard-user-card">
                <h3>Account Details</h3>

                <p>
                  <strong>Name:</strong> {user.fname} {user.lname}
                </p>

                <p>
                  <strong>Email:</strong>{" "}
                  <span style={{ textTransform: "lowercase" }}>
                    {user.email}
                  </span>
                </p>

                <p>
                  <strong>Phone:</strong> {user.phone}
                </p>
              </div>

              {/* <div className="stats">
                <div className="stat-card">
                  <h3>Orders</h3>
                  <p>{ordersCount}</p>
                </div>

                <div className="stat-card">
                  <h3>Wishlist</h3>
                  <p>{wishlistCount}</p>
                </div>

                <div className="stat-card">
                  <h3>Account ID</h3>
                  <p>#{user.id}</p>
                </div>
              </div> */}
            </>
          )}

          {activeTab === "profile" && (
  <Profile
    onProfileUpdated={(updatedUser) => {
      setUser(updatedUser);
    }}
  />
)}

          {activeTab === "orders" && <Orders/>}

          {activeTab === "wishlist" && (
            <div className="dashboard-wishlist">
              <WishlistPage hideLayout={true} />
            </div>
          )}
        </div>
      </div>
       {showLogoutPopup && (
  <div className="logout-popup-overlay">
    <div className="logout-popup">
      <h3>Are you sure?</h3>

      <p>Do you really want to logout from your account?</p>

      <div className="logout-popup-actions">
        <button
          className="cancel-logout-btn"
          onClick={() => setShowLogoutPopup(false)}
        >
          Cancel
        </button>

        <button
          className="confirm-logout-btn"
          onClick={handleLogout}
        >
          Yes, Logout
        </button>
      </div>
    </div>
  </div>
)}
      <Footer />
    </>
  );
};

export default Dashboard;